export default __webpack_public_path__ + "static/media/lysningen-property-11.e05f502f.jpg";